import React, { useState } from "react"
import { useNavigate } from "react-router-dom"
import "../styles/Pages/settings.css"
import MyDetails from "../components/Settings/MyDetails"
import Plan from "../components/Settings/Plan"
import ResetPassword from "../components/Settings/ResetPassword"
import { useSelector } from "react-redux"
import { Spin } from "antd"
import { translations } from "../utils/Translation/staticTranslation"

function Setting() {
  const navigate = useNavigate()
  const { loading } = useSelector((state) => state.user)
  const [activeTab, setActiveTab] = useState("myDetails") // Default tab

  const lang = localStorage.getItem("language") || "ar"
  const settingPage = translations[lang]?.settingPage

  return (
    <div>
      <div className="d-flex mb-18">
        <div></div>
        <div>
          <h1 className="text-141414 text-20">{settingPage?.settings} </h1>
          <p className="text-504943 text-13">
            {settingPage?.profile_text}{" "}
            <span className="text-85849D">/ {settingPage?.menu_text}</span>
          </p>
        </div>
      </div>

      <div className="content-fit-container">
        <p className="text-16 font-600 text-0A083B mb-18">
          {settingPage?.setup_profile_text}
        </p>
        <div className="d-flex">
          {/* Sidebar */}
          <div className={`p-24  ${lang === "ar" ? "ml-40" : "mr-40"} `}>
            <div
              className={`text-13 pointer mb-32 ${
                activeTab === "myDetails" ? " text-FB6514" : "text-3F3F3F"
              }`}
              onClick={() => setActiveTab("myDetails")}
            >
              <img
                className={`${lang === "ar" ? "ml-10" : "mr-10"}`}
                src={`/settings/${
                  activeTab === "myDetails"
                    ? "profileActive.svg"
                    : "profile.svg"
                }`}
                alt=""
              />{" "}
              {settingPage?.my_details}
            </div>
            <div
              className={`text-13  mb-32 pointer ${
                activeTab === "resetPassword" ? " text-FB6514" : "text-3F3F3F"
              }`}
              onClick={() => setActiveTab("resetPassword")}
            >
              <img
                className={`${lang === "ar" ? "ml-10" : "mr-10"}`}
                src={`/settings/${
                  activeTab === "resetPassword"
                    ? "ResetPasswordActive.svg"
                    : "ResetPassword.svg"
                }`}
                alt=""
              />{" "}
              {settingPage?.reset_password}
            </div>
          </div>

          <div
            className={`vertical-separator  ${
              lang === "ar" ? "ml-24" : "mr-24"
            } `}
          ></div>

          {/* Dynamic Content */}
          {/* <div className="flex-grow-1"> */}

          {activeTab === "myDetails" &&
            (!loading ? (
              <MyDetails />
            ) : (
              <div className="w-100 h-100 d-flex justify-content-center align-items-center">
                <Spin size="large" />
              </div>
            ))}
          {activeTab === "resetPassword" && <ResetPassword />}
          {/* {activeTab === "plan" && <Plan />} */}

          {/* </div> */}
        </div>
      </div>
    </div>
  )
}

export default Setting
